// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2QSLU","search":"Settings_search__3NTIf","filter":"Settings_filter__16GmJ"};